import { composeReducers } from '../../util';

import {
  defaultState as loadingState,
  startLoading,
  stopLoading,
} from '../../loading/reducer';

import {
  LOAD,
  LOAD_SUCCESS,
  LOAD_ERROR,
} from './actions';

const initial = {
  ...loadingState,
  version: null,
  error: null,
};

const load = composeReducers(
  () => initial,
  startLoading,
);

const loadSuccess = composeReducers(
  stopLoading,
  (state, { version }) => ({
    ...state,
    version,
  }),
);

const loadError = composeReducers(
  stopLoading,
  (state, { error }) => ({
    ...state,
    error,
  }),
);

export default (state = initial, action) => {
  const reducer = {
    [LOAD]: load,
    [LOAD_SUCCESS]: loadSuccess,
    [LOAD_ERROR]: loadError,
  }[action.type];

  return reducer ? reducer(state, action) : state;
};
